<template>
  <div class="main-content ">
    <div class="choose-page">
      <div class="container ">
        <div class="choose-area">
          <h3 class="choose-area__store-name">
            Hi, {{ branchName }} {{ name }}
          </h3>
          <div class="row choose-area__service">
            <div class="col-md-4 col-6">
              <router-link
                :to="{ name: '銷售' }"
                class="choose-area__service-block"
              >
                <img src="~@/assets/img/photos/menu-choose/sale.png" alt="" />
                <p class="choose-area__service-block--title">銷售</p>
              </router-link>
            </div>
            <div class="col-md-4 col-6">
              <router-link
                :to="{ name: '課程點名' }"
                class="choose-area__service-block"
              >
                <img
                  src="~@/assets/img/photos/menu-choose/roll-call.png"
                  alt=""
                />
                <p class="choose-area__service-block--title">課程點名</p>
              </router-link>
            </div>
            <div class="col-md-4 col-6">
              <router-link
                :to="{ name: '會員註冊' }"
                class="choose-area__service-block"
              >
                <img src="~@/assets/img/photos/menu-choose/member.png" alt="" />
                <p class="choose-area__service-block--title">會員註冊</p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['name', 'branchName'])
  },
  data() {
    return {
      // Store the meta element
      viewport_meta: document.getElementById('viewport-meta'),
      // Define our viewport meta values
      viewports: {
        default: 'width=device-width',
        landscape: 'width=1400'
      }
    };
  },
  components: {},
  created() {
    // 來到這個頁面,viewport設成有手機版的頁面
    this.viewportSet(this.viewport_meta, this.viewports);
  },
  beforeRouteLeave(to, from, next) {
    // 離開這個頁面,viewport設回只有電腦版寬度
    this.viewportSetWideVersion(this.viewport_meta, this.viewports);
    next();
  },
  methods: {
    viewportSet(viewport_meta, viewports) {
      if (screen.width > 768) {
        viewport_meta.setAttribute('content', viewports.landscape);
      } else {
        viewport_meta.setAttribute('content', viewports.default);
      }
    },
    viewportSetWideVersion(viewport_meta, viewports) {
      viewport_meta.setAttribute('content', viewports.landscape);
    }
  }
};
</script>
